(function ($) {
    const color_scheme_manager = new ColorSchemeManager();

    $.sa = $.extend($.sa || {}, {
        route_uri: '/',
        is_debug: false,
        is_admin: false,
        nationality: 'RU',
        abtest: null,
        is_mobile: function (end = 560) {
            var window_width = window.innerWidth;
            return window_width <= end;
        },
        is_tablet: function (start = 560, end = 1200) {
            var window_width = window.innerWidth;
            return window_width > start && window_width < end;
        },
        is_desktop: function (start = 1200) {
            var window_width = window.innerWidth;
            return window_width >= start;
        },
        is_touch: function () {
            return window.matchMedia('(pointer: coarse)').matches;
        },
        is_dark_theme: function () {
            return color_scheme_manager.isDark();
        },
        mobile_app: new saMobileApp(),
        validate: {
            email: function (email) {
                var regex = /^[^\s@]+@[^\s@]+\.[^\s@.]{2,}$/,
                    regex_two_more_dots = /[.]{2,}/,
                    is_valid = false;

                if (email.match(regex) && !email.match(regex_two_more_dots)) {
                    is_valid = true;
                }

                return is_valid;
            }
        },
        calendar: { // Set in _layout.html
            months: {
                short: [],
                full: []
            },
            weekdays: {
                short: [],
                full: []
            }
        },
        browser: {
            firefox: /firefox/i.test(navigator.userAgent),
            msedge: /edge\/\d+/i.test(navigator.userAgent),
            msie: /(msie|trident)/i.test(navigator.userAgent),
            mobile: /android|webos|iphone|ipad|ipod|blackberry/i.test(navigator.userAgent),
            webkit: /webkit/i.test(navigator.userAgent) && !/edge\/\d+/i.test(navigator.userAgent)
        },
        os: {
            macosx: /mac/i.test(navigator.userAgent),//navigator.platform is deprecated: https://developer.mozilla.org/en-US/docs/Web/API/Navigator/platform
            windows: /windows/i.test(navigator.userAgent)
        },
        $window: $(window),
        $document: $(document),
        $head: $('head'),
        $content: null, // Set in _layout.html
        layout: {
            site: {
                name: 'site',
                class: 'layout-site',
            },
            engine: {
                name: 'engine',
                class: 'layout-engine',
            },
        },
        get_layout: function () {
            return $.sa.$document.find('.js-layout-container').data('layout') || $.sa.layout.engine.name;
        },
        loading_bar: $.uiLoadingBar(),
        content_router: null, // Set in initContentRouter()

        build_url: function (href) {
            return this.route_uri + href
        },

        confirm: {
            show: showConfirm,
            template: ''
        },
        alert: {
            show: showAlert,
            template: ''
        },
        notifier: {
            class: {
                warning: 'warning',
                success: 'success',
                plain: 'plain',
                error: 'error',
                accent: 'accent',
            },
            show: showNotifier,
            template: ''
        },

        title: {
            set: function (title_string) {
                if (title_string) {
                    var state = history.state;
                    if (state) {
                        state.title = title_string;
                    }
                    document.title = title_string;
                }
            }
        },
        locale_code: 'ru_RU', // Update in _layout.html
        current_locale_config: null, // Set in _layout.html
        support_locales: null, // Set in _layout.html
        locales: {},
        form: {
            loading: function ($node, is_loading) {
                var class_name = 'sa-form-loading';
                if (is_loading) {
                    $node.addClass(class_name);
                } else {
                    $node.removeClass(class_name);
                }
            }
        },

        //
        in_developing_modal: null, // Set in _layout.html
        smartup_modal: null, // Set in _layout.html,
        smartup_brand_modal: null, // Set in _layout.html
        smartup_login: null, // Set in _layout.html
        cookies_policy_template: null, // Set in _layout.html

        //
        og: {
            get: function (name) {
                $.sa.og.__getItem(name).attr('content');
            },
            set: function (name, value) {
                var $item = $.sa.og.__getItem(name);
                if ($item.length) {
                    $item.attr('content', value);
                } else {
                    var meta_tag = '<meta property="og:' + name + '" content="' + value + '">';
                    $.sa.$head.append(meta_tag);
                }
            },
            __getItem: function (name) {
                return $.sa.$head.find('meta[property="og:' + name + '"]');
            }
        },

        //
        getCookie: function (name) {
            const cookies = document.cookie.split(';');
            for (let cookie of cookies) {
                const [cookie_name, cookie_value] = cookie.trim().split('=');
                if (cookie_name === name) {
                    return decodeURIComponent(cookie_value);
                }
            }
            return null;
        },

        /**
         *
         * @param name
         * @param value
         * @param path
         * @param max_age_days Количество дней, на которое нужно хранить куку. Если 0, то кука будет удалена после закрытия браузера.
         */
        setCookie: function (name, value = '', path = '/', max_age_days = 0) {
            let max_age = '';
            if (max_age_days) {
                max_age = `;max-age=${max_age_days * 24 * 60 * 60}`;
            }

            document.cookie = `${name}=${value};path=${path};max-age=${max_age}`;
        },

        isSetCookie: function (name) {
            return document.cookie.split(';').some(function (item) {
                return item.indexOf(name + '=') !== -1;
            });
        },

        //
        init: function (options) {
            $.sa.$content = options['$content'];
            $.sa.notifer_storefront = options['notifer_storefront'];

            $.sa.analytics.params({'strf': options['strf']});

            if ($.sa.is_dark_theme()) {
                $.sa.analytics.reachGoal('dark-theme');
            }

            //
            initTimeStart();
            //
            initErrorHandler();
            //
            initContentRouter();
            //
            cleanUrl();
            setupLocaleSwitchUrls();
            //
            initNotifierStorefront();
            //
            initCookiesPolicy();
            //
            initReachGoals();
            //
            initInDevelopmentModal();
            initSmartupModal();
            initSmartupBrandModal();
            initSmartupBrandModalLogin()
            initSmartupSupportChat();
            //
            initSetCookie();
            initResetCookie();
            initRefreshUrl();

            // TODO: $('.js-header-notifications-dd-wrapper').dd();
            // TODO: $('.js-header-profile-dd-wrapper').dd();

            //
            new UIInput();
            //
            new UIInputMask();
            //
            new UITextarea();
            //
            new UISelect();
            //
            new UISelectButton();
            //
            new UISelectSearch();
            //
            new UICheckbox();
            //
            new UIDropdown();
            //
            new UIDropdownDrawer();
            //
            new UIHint();
            //
            new UICounter();
            //
            new UIAccordion();
            //
            new UIAlertToggle();
            //
            new UITab();
            //
            new UITooltip();
            //
            new UIToggle();
            //
            new UICopy();
            //
            new ShareLinkWatcher();
            //
            new UIFileUploader();
            //
            new UIButtonTags();
            //
            new visuallyImpairedSettings({
                drawer_html: options['visually_impaired_settings_drawer']
            });

            //
            var auth_modal_title = options['auth_modal_title'],
                auth_modal_content = options['auth_modal_content'];
            if (auth_modal_title && auth_modal_content) {
                new AuthModal({
                    modal_title: auth_modal_title,
                    modal_content: auth_modal_content,
                });
            }
        },

        flocktory: {
            class: {
                main: 'i-flocktory',
            },

            push(data) {
                if (!window.flocktory) window.flocktory = [];
                window.flocktory.push(data);
            },

            /**
             * @param category_id
             */
            trackCategoryView(category_id) {
                if (!category_id || !$.sa.$content) {
                    return;
                }
                var $element = $('<div />')
                    .hide()
                    .addClass($.sa.flocktory.class.main)
                    .attr('data-fl-action', 'track-category-view')
                    .attr('data-fl-category-id', category_id);
                $.sa.$content.append($element);
            },

            /**
             * @param item_id
             * @param category_id
             */
            trackItemView(item_id, category_id) {
                if (!item_id || !category_id || !$.sa.$content) {
                    return;
                }
                var $element = $('<div />')
                    .hide()
                    .addClass($.sa.flocktory.class.main)
                    .attr('data-fl-action', 'track-item-view')
                    .attr('data-fl-item-id', item_id)
                    .attr('data-fl-item-category_id', category_id);

                $.sa.$content.append($element);
            },

            /**
             * @param data = {name,email}
             */
            trackUserView(data) {
                if (!data || !$.sa.$content) {
                    return;
                }

                var name = data?.name,
                    email = data?.email,
                    $element = $('<div />')
                        .hide()
                        .addClass($.sa.flocktory.class.main);

                name && $element.attr('data-fl-user-name', name);
                email && $element.attr('data-fl-user-email', email);

                $.sa.$content.append($element);
            },
        },

        analytics: {
            ym_id: null, // set in _layout.html

            /**
             * @return {Promise}
             * */
            getYM() {
                const that = this;

                return new Promise(function (resolve, reject) {
                    // Reject: Если нет ym_id
                    if (!that.ym_id) {
                        reject();

                        // Resolve: если уже YM готов
                    } else if (window.ym) {
                        resolve(window.ym);

                        // Await Resolve: ждем когда YM будет готов
                    } else {
                        const event_name = "yacounter" + that.ym_id + "inited";
                        $.sa.$document.one(event_name, function () {
                            resolve(window.ym);
                        });
                    }
                });
            },

            /**
             * @param {Object|Object[]} data
             * @param {Boolean} reset
             */
            ecommerce(data, reset) {
                if (!Array.isArray(data)) {
                    data = [data];
                }
                if (reset) {
                    data.unshift({ecommerce: null});
                }
                $.sa.analytics.events(data);
            },

            /**
             * На всякий случай дублирует код оригинальной гугловской функции gtag на случай, если TagManager не подключен
             */
            gtag() {
                if (!window.gtag) window.gtag = function () {
                    if (!window.dataLayer) window.dataLayer = [];
                    window.dataLayer.push(arguments);
                };
                window.gtag.apply(null, arguments);
            },

            /**
             * @param content_type
             * @param content_id
             */
            gtagSelectContent(content_type, content_id) {
                $.sa.analytics.gtag('event', 'select_content', {
                    content_type: content_type,
                    content_id: content_id
                });
            },

            /**
             * @param {Object|Object[]} data
             */
            events(data) {
                window.dataLayer = window.dataLayer || [];
                if (!Array.isArray(data)) {
                    data = [data];
                }
                data.forEach(function (ga_evt) {
                    window.dataLayer.push(ga_evt);
                })
            },

            hit(url, options = {}) {
                $.sa.analytics.getYM().then(function (ym) {
                    ym($.sa.analytics.ym_id, 'hit', url, options);
                }).catch(function () {});
            },

            params(params = {}) {
                $.sa.analytics.getYM().then(function (ym) {
                    ym($.sa.analytics.ym_id, 'params', params);
                }).catch(function () {});
            },

            reachGoal(target, params = {}) {
                $.sa.analytics.getYM().then(function (ym) {
                    ym($.sa.analytics.ym_id, 'reachGoal', target, params);
                }).catch(function () {});
            }
        },

        airlineIconUrl: function (airline_iata_code, width, height, as_square) {
            var host = 'https://mpics.avs.io/';
            if (as_square) {
                host += 'al_square/';
            }
            return host + width + '/' + height + '/' + airline_iata_code + '.png';
        },
        validateUserField: function (field_name, field_value) {
            var href = this.build_url('api/user/field_validator'),
                data = {
                    field: field_name,
                    value: field_value,
                }

            var result = false;

            $.ajax({
                type: 'post',
                url: href,
                data: data,
                async: false,
                success: function (res) {
                    result = res.data;
                }
            });

            return result
        },
        escape: function (string) {
            return $('<div />').text(string).html();
        },
        shake: function ($node, focus) {
            $node.addClass('shake animated');
            if (focus) {
                $node.focus();
            }
            setTimeout(function () {
                $node.removeClass('shake animated').focus();
                if (focus) {
                    $node.focus();
                }
            }, 500);
        },
        buttonLoading: function ($button, set = true) {
            $button.toggleClass('loading', !!set);
        },
        initMarqueeAnimation: function ($animate_wrapper) {
            var animate_class = 'marquee-animate',
                $animate_container = $animate_wrapper.find('.js-marquee-animate-container'),
                $animate_item = $animate_container.find('.js-marquee-animate-item'),
                wrapper_width = $animate_wrapper.width(),
                item_width = $animate_item.width();

            if (!$animate_wrapper.length || !$animate_container.length || !$animate_item.length) {
                return;
            }

            item_width += 6;

            if (item_width > wrapper_width) {
                var translate_amount = item_width - wrapper_width,
                    animate_duration = translate_amount / 7;

                $animate_wrapper[0].style.setProperty('--marqueeTranslateAmount', '-' + translate_amount + 'px');
                $animate_wrapper[0].style.setProperty('--marqueeAnimDuration', animate_duration + 's');
                $animate_container.addClass(animate_class);
            } else {
                $animate_container.removeClass(animate_class);
                $animate_wrapper[0].style.removeProperty('--marqueeTranslateAmount');
                $animate_wrapper[0].style.removeProperty('--marqueeAnimDuration');
            }

            this.$window.on('resize', function () {
                $.sa.initMarqueeAnimation($animate_wrapper);
            });
        },

        //

        postMessage: function (msg) {
            msg.message_source = 'avia';
            window.parent.postMessage(JSON.stringify(msg), '*');
        },

        //

        log: function (...args) {
            if (
                ($.sa.is_debug || $.sa.is_admin) &&
                console &&
                console.log
            ) {
                console.log(...args);
            }
        },
        error: function (...args) {
            if (
                ($.sa.is_debug || $.sa.is_admin) &&
                console &&
                console.error
            ) {
                console.error(...args);
            }
        },

        //

        prepareFlightItem: function ($node, flight, onClick) {
            $node.removeClass('js-template').removeAttr('style');

            $node.attr('data-id', flight.id).data('id', flight.id);

            $node.find('.js-flight-number').text(flight.flight_number);
            $node.find('.js-airline-logo').attr('src', $.sa.airlineIconUrl(flight.airline_code, 32, 32, true)).attr('alt', flight.airline.name);
            $node.find('.js-airline-name').text(flight.airline.name);

            $node.find('.js-departure-time').text(flight.departure_local.time);
            $node.find('.js-departure-date').text(flight.departure_local.date_month);
            $node.find('.js-departure-year').text(flight.departure_local.year);
            $node.find('.js-departure-day-short').text(flight.departure_local.day_short);

            $node.find('.js-arrival-time').text(flight.arrival_local.time);
            $node.find('.js-arrival-date').text(flight.arrival_local.date_month);
            $node.find('.js-arrival-year').text(flight.arrival_local.year);
            $node.find('.js-arrival-day-short').text(flight.arrival_local.day_short);

            $node.find('.js-duration').text(flight.duration_full);

            $node.find('.js-departure-airport-name').text(flight.departure_airport.name);
            $node.find('.js-departure-airport-code').text(flight.departure_airport.iata_code);
            $node.find('.js-departure-city').text(flight.departure_airport.municipality);

            $node.find('.js-arrival-airport-name').text(flight.arrival_airport.name);
            $node.find('.js-arrival-airport-code').text(flight.arrival_airport.iata_code);
            $node.find('.js-arrival-city').text(flight.arrival_airport.municipality);

            if (onClick && typeof onClick === 'function') {
                $node.on('click', onClick)
            }
        },
        initAutocomplete: function ($input, $value, request_url) {
            var onSelect = function (e, ui) {
                e.preventDefault();
                $input.val($.sa.escape(ui.item.value));
                $value.val(ui.item.id);
            };

            $input.autocomplete({
                appendTo: $input.parent(),
                source: request_url,
                minLength: 2,
                html: true,
                focus: function () {
                    return false;
                },
                select: onSelect,
            }).data('ui-autocomplete')._renderItem = function (ul, item) {
                var $item = $('<li />');
                $item.addClass('ui-menu-item-html').append('<div>' + item.label + '</div>').appendTo(ul);
                return $item;
            };

            $input.on('focus', function () {
                $input.data('uiAutocomplete').search($input.val());
            });

            $input.on('input', function (e) {
                e.preventDefault();
                $value.val('');
            });
        },

        //

        pregMatch: function (query, string) {
            var query_is_string = (typeof query == 'string');
            if (query_is_string && !query.length) {
                return false;
            }

            var filter = query_is_string ? new RegExp(query, 'i') : query,
                matched = false;

            if (filter) {
                string = '' + string;
                matched = string.match(filter);
            }

            return matched;
        },
        escapeRegExp: function (string) {
            return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        },
        swapLetters: function (string, reverse) {
            var replacer = {
                    "q": "й", "w": "ц", "e": "у", "r": "к", "t": "е", "y": "н", "u": "г", "i": "ш", "o": "щ", "p": "з",
                    "[": "х", "]": "ъ", "a": "ф", "s": "ы", "d": "в", "f": "а", "g": "п", "h": "р", "j": "о", "k": "л",
                    "l": "д", ";": "ж", "'": "э", "z": "я", "x": "ч", "c": "с", "v": "м", "b": "и", "n": "т", "m": "ь",
                    ",": "б", ".": "ю", "/": ".",
                },
                replace,
                i;

            reverse && Object.keys(replacer).forEach(key => {
                var v = replacer[key]
                delete (replacer[key])
                replacer[v] = key
            })

            for (i = 0; i < string.length; i++) {
                if (replacer[string[i].toLowerCase()] != undefined) {

                    if (string[i] == string[i].toLowerCase()) {
                        replace = replacer[string[i].toLowerCase()];
                    } else if (string[i] == string[i].toUpperCase()) {
                        replace = replacer[string[i].toLowerCase()].toUpperCase();
                    }

                    string = string.replace(string[i], replace);
                }
            }

            return string;
        },
        localePlural: function (n, text_forms) {
            n = Math.abs(n) % 100;
            var n1 = n % 10;
            if (n > 10 && n < 20) {
                return text_forms[2];
            }
            if (n1 > 1 && n1 < 5) {
                return text_forms[1];
            }
            if (n1 === 1) {
                return text_forms[0];
            }
            return text_forms[2];
        },
        nameLiterals: function (firstname, lastname) {
            return (lastname.toString().charAt(0) + firstname.toString().charAt(0)).toUpperCase();
        },

        parseDatetime: function (datetime) {
            var datetime_object = dayjs(datetime),
                datetime_month_index = datetime_object.format('M') - 1,
                datetime_weekday_index = datetime_object.format('d');

            return {
                year: {
                    full: datetime_object.format('YYYY'),
                    short: datetime_object.format('YY'),
                },
                month: {
                    index: datetime_month_index,
                    number: datetime_object.format('MM'),
                    name_full: $.sa.locales.months.full[datetime_month_index],
                    name_short: $.sa.locales.months.short[datetime_month_index],
                    sql: datetime_object.format('YYYY-MM'),
                },
                day: {
                    week_index: parseInt(datetime_object.format('d'), 10),
                    number: datetime_object.format('D'),
                    weekday_full: $.sa.locales.weekdays.full[datetime_weekday_index],
                    weekday_short: $.sa.locales.weekdays.short[datetime_weekday_index],
                    sql: datetime_object.format('YYYY-MM-DD'),
                    input: datetime_object.format('DD.MM.YYYY')
                }
            };
        },

        /**
         * Получить время года (сезон) на основе указанной даты
         * @param datetime
         * @returns {string}
         */
        parseSeason(datetime) {
            var month = parseInt(dayjs(datetime).format('M'));

            switch (month) {
                case 12:
                case 1:
                case 2:
                    return 'winter';
                case 3:
                case 4:
                case 5:
                    return 'spring';
                case 6:
                case 7:
                case 8:
                    return 'summer';
                case 9:
                case 10:
                case 11:
                    return 'autumn';
            }
        },

        //

        copyToBuffer: function (value) {
            var temproray_input = document.createElement('input');
            temproray_input.setAttribute('value', value);
            document.body.appendChild(temproray_input);
            temproray_input.select();
            document.execCommand('copy');
            document.body.removeChild(temproray_input);
        },

        /**
         * Скроллирует страницу по вертикали к заданному jQ-элементу плюс произвольное смещение по вертикали
         *
         * @param {jQuery} $node элемент до которого нужно прокрутить экран
         * @param {Number?} transition скорость прокрутки
         * @param {Number?} offset произвольное смещение относительно указанного элемента
         * @return {jQuery} jQuery объект, пригодный для использования, например, с .promise()
         */
        scrollToNode: function ($node, transition = 300, offset = null) {
            return $('html,body').animate({
                scrollTop: $node.offset().top + offset
            }, transition);
        },

        /**
         * Locked\Unlocked body scroll
         * this == that == $.sa.scroll_locker
         */

        scroll_locker: {
            $html: null,
            $body: null,
            is_locked: false,
            is_force_locked: false,
            is_scroll_locked: false,
            getHtml() {
                const that = this;
                that.$html = (that.$html ? that.$html : $(document.documentElement));
                return that.$html;
            },
            getBody() {
                const that = this;
                that.$body = (that.$body ? that.$body : $(document.body));
                return that.$body;
            },

            /**
             * @param {Boolean?} force
             * @return {Boolean}
             * */
            locked(force = false) {
                const that = this;

                const result = that.lock(true);
                if (force) {
                    that.is_force_locked = true;
                }

                return result;
            },
            /**
             * @param {Boolean?} force
             * @return {Boolean}
             * */
            unlocked(force = false) {
                const that = this;

                if (force) {
                    that.is_force_locked = false;
                }

                return that.lock(false);
            },
            /**
             * @param {Boolean} lock_up
             * @return {Boolean}
             * */
            lock(lock_up) {
                const that = this;

                if (that.is_force_locked) {
                    return that.is_locked;
                }

                const $html = that.getHtml(),
                    $body = that.getBody();

                const locked_class = 'is-locked',
                    scrollbar_class = 'with-scrollbar';

                if (lock_up !== that.is_locked) {
                    if (lock_up) {
                        const is_scroll_visible = isScrollVisible();
                        if (is_scroll_visible) {
                            $html.addClass(scrollbar_class);
                            that.is_scroll_locked = true;
                        }

                        /**
                         * Хак для мобильных:
                         * TouchMove на html/body позволяет скролить страницу в обход CSS правил.
                         * Отключаем через event.preventDefault
                         * */
                        $html[0].addEventListener('touchmove', lockScroll);
                        $body[0].addEventListener('touchmove', lockScroll);

                        $html.addClass(locked_class);

                    } else {
                        $html.removeClass(locked_class);

                        $html[0].removeEventListener('touchmove', lockScroll);
                        $body[0].removeEventListener('touchmove', lockScroll);

                        if (that.is_scroll_locked) {
                            $html.removeClass(scrollbar_class);
                            that.is_scroll_locked = false;
                        }
                    }

                    that.is_locked = lock_up;
                }

                return that.is_locked;

                function lockScroll(event) {
                    event.preventDefault();
                }

                function isScrollVisible() {
                    const height = window.innerHeight,
                        scroll_height = document.body.scrollHeight;

                    /**
                     * Хак для FF: страница без видимого скролла, почему-то имеет scrollHeight больше видимой области на 1px
                     * (возможно из-за масштабирования системы или округления дробных пикселей)
                     * */
                    return (scroll_height - height > 1);
                }
            }
        },

        stickyObserver: function (observe_to, class_is_stick) {
            var el = $(observe_to)[0],
                callback = function (e) {
                    var $target = $(e[0].target)
                    if (e[0].intersectionRatio < 1) {
                        $target.addClass(class_is_stick);
                    } else {
                        $target.removeClass(class_is_stick);
                    }
                },
                options = {
                    threshold: [1]
                },
                observer = new IntersectionObserver(callback, options);

            observer.observe(el);
        },
        pagination: function ($wrapper, list_url, list_url_params = {}) {
            var $list = $wrapper.find('.js-list'),
                $load_more_wrapper = $wrapper.find('.js-load-more-wrapper'),
                page = 1,
                is_locked = false;

            var load = function () {
                $.sa.buttonLoading($load_more_wrapper.find('.js-load-more'), true);

                var data = {
                    page: page + 1,
                    ...list_url_params
                };

                $.post(list_url, data, function (res) {
                    if (!res) {
                        $.sa.handleErrors();
                        return;
                    }
                    handleSuccess(res);
                }).fail(function () {
                    $.sa.handleErrors();
                }).always(function () {
                    $.sa.buttonLoading($load_more_wrapper.find('.js-load-more'), false);
                    is_locked = false;
                });
            };

            var handleSuccess = function (res) {
                var $res = $(res),
                    $loaded_list = $res.find('.js-list'),
                    $loaded_load_more_wrapper = $res.find('.js-load-more-wrapper');

                $list.append($loaded_list.html());
                if ($loaded_load_more_wrapper.length) {
                    $load_more_wrapper.html($loaded_load_more_wrapper.html());
                } else {
                    $load_more_wrapper.remove();
                }

                page++;
            }

            $wrapper.on('click', '.js-load-more', function (e) {
                e.preventDefault();

                if (is_locked) {
                    return false;
                }
                is_locked = true;

                load();
            });
        },

        format: {
            price: function (price, currency) {
                // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
                var options = {
                    style: 'currency',
                    currency: currency,
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                };
                return new Intl.NumberFormat($.sa.current_locale_config['code_ietf'], options).format(price);
            },
        },

        //

        handleSuccess: function (title) {
            $.sa.notifier.show({
                notifier_class: $.sa.notifier.class.success,
                title: title,
            });
        },

        handleErrors: function (errors) {
            if (!errors) {
                errors = [[]];
            }
            if (errors.constructor.name !== 'Array') {
                errors = [errors];
            }

            $.each(errors, function (i, error) {
                $.sa.notifier.show({
                    notifier_class: $.sa.notifier.class.error,
                    title: error.title || $.sa.locales['error'],
                    content: error.message || $.sa.locales['something_went_wrong']
                });
            });
        },

        //

        encodeSearchPath: function (search_params) {
            var result = '',
                first_origin_airport,
                prev_destination_airport,
                last_origin_airport;

            // Directions
            $.each(search_params.directions, function (i, direction) {
                if (i === 0) {
                    first_origin_airport = direction.origin;
                }
                var is_last_iteration = i === search_params.directions.length - 1;
                if (is_last_iteration) {
                    last_origin_airport = direction.destination;
                }

                if (!prev_destination_airport || prev_destination_airport !== direction.origin) {
                    result += direction.origin;
                }

                result += '-' + dayjs(direction.date).format('DDMM');

                if (!is_last_iteration || first_origin_airport !== last_origin_airport) {
                    result += '-' + direction.destination;
                }

                prev_destination_airport = direction.destination;
            });

            // Passengers
            var passengers_count = search_params.passengers.count,
                passenger_categories = Object.keys(search_params.passengers.values).sort();

            $.each(passenger_categories, function (i, passenger_category) {
                var passenger_category_count = parseInt(search_params.passengers.values[passenger_category]);

                if (i === 0) {
                    result += '-';
                }

                result += passenger_category_count;

                passengers_count -= passenger_category_count;
                if (!passengers_count) {
                    return false;
                }
            })

            return result;
        },
        decodeSearchPath: function (search_path) {
            var result = {
                directions: [],
                passengers: {
                    adt: 1,
                    chd: 1,
                    cnn: 1,
                    inf: 0,
                    ins: 0,
                    src: 0,
                    yth: 0,
                },
            };

            // TODO !!!

            return result;
        },

        share(options) {
            return new ShareLink(options);
        },

        /**
         * Код варианта A/B теста с кодом test_code, назначенный посетителю.
         * null если тест неактивен или посетителю не назначено вариантов
         *
         * @param {string} test_code
         * @return {*|string}
         */
        ab(test_code) {

            if (!$.sa.abtest) {
                return null;
            }

            return $.sa.abtest[test_code] || null;
        },

        color_scheme_manager,

        utils: {
            /**
             * @param {Object} data
             * @param {String} key
             * @return {String}
             * */
            localeField(data, key) {
                let result = "";

                if (data && data[key]) {
                    result = data[key];

                    const locale = ($.sa.locale_code ? $.sa.locale_code.substring(0, 2) : 'ru');
                    if (locale !== 'en') {
                        key = key + "_" + locale;
                        if (data[key]) {
                            result = data[key];
                        }
                    }
                }

                return result;
            },

            /**
             * @param {Object|Array} data
             * @param {String|Number} key
             * @return {Object}
             * */
            groupBy(data, key) {
                const result = {};

                $.each(data, function (i, data_item) {
                    const value = data_item[key];

                    switch (typeof value) {
                        case 'number':
                        case 'string':
                            result[value] = (result[value] || []);
                            result[value].push(data_item);
                            break;

                    }
                });

                return result;
            },

            /**
             * @param {String} string
             * @return {String}
             * */
            nl2br(str) {
                return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
            }
        }
    });

    function initTimeStart() {
        setTimeout(function () {
            tick();
        }, 1000);

        function tick() {
            var unixtime = dayjs($.sa.server_datetime, 'YYYY-MM-DD HH:mm:ss').unix();
            // increase server_datetime on 1 second
            $.sa.server_datetime = dayjs.unix(unixtime + 1).format('YYYY-MM-DD HH:mm:ss');

            setTimeout(function () {
                tick();
            }, 1000);
        }
    }

    function initCookiesPolicy() {
        if (!$.sa.cookies_policy_template) {
            return;
        }

        const cookies_name = 'cookies_policy',
            cookies_age_days = 365;

        if (!$.sa.isSetCookie(cookies_name)) {
            const storage_event_name = 'cookies_policy_accepted',
                $body = $.sa.$document.find('body'),
                $wrapper = $($.sa.cookies_policy_template).clone(),
                $accept_button = $wrapper.find('.js-cookies-policy-accept');

            $body.append($wrapper);

            $accept_button.on('click', function () {
                renewCookiePolicy();
                $wrapper.remove();
                
                // generate event for other tabs
                localStorage.setItem(storage_event_name, Date.now());
                localStorage.removeItem(storage_event_name);
            });

            // hide cookies policy banner in other tabs
            $.sa.$window.on('storage', function (e) {
                if (e.originalEvent.key === storage_event_name) {
                    $wrapper.remove();
                }
            });
            return;
        }

        if (parseInt($.sa.getCookie(cookies_name))) {
            // renew cookie for infinite time
            renewCookiePolicy();
        } else {
            // action if cookie policy not accepted
        }

        // functions
        function renewCookiePolicy() {
            $.sa.setCookie(cookies_name, 1, '/', cookies_age_days);
        }
    }

    function initNotifierStorefront() {
        if ($.sa.notifer_storefront && $.sa.notifer_storefront.length) {
            $.sa.notifier.show({
                title: $.sa.notifer_storefront,
                content: '',
            });
        }
    }

    function initReachGoals() {
        $.sa.$document.on('click', '.js-reachgoal[data-reachgoal]', function (e) {
            var $this = $(this),
                target = $this.data('reachgoal'),
                params = $this.data('reachgoal-params') || {}; // ???

            $.sa.analytics.reachGoal(target, params);
        });
    }

    function initInDevelopmentModal() {
        $.sa.$document.on('click', '.js-in-development', function (e) {
            e.preventDefault();

            var $wrapper = $($.sa.in_developing_modal).clone(),
                $this = $(this),
                href = $this.data('href'),
                separator = href.indexOf('?') === -1 ? '?' : '&';

            $.uiModal({
                $wrapper: $wrapper,
                onOpen: function ($modal_wrapper, modal) {
                    var $go = $modal_wrapper.find('.js-go');

                    $go
                        .attr('href', href + separator + 'utm_source=traffic_back')
                        .on('click', function () {
                            modal.close();
                        });
                }
            });
        });
    }

    function initSmartupModal() {
        $.sa.$document.on('click', '.js-modal-smartup', function (e) {
            e.preventDefault();

            var $wrapper = $($.sa.smartup_modal).clone();

            $.uiModal({
                $wrapper: $wrapper,
                lock_body_scroll: true,
                onOpen: function () {
                    $.uiScrollbar($wrapper.find('.scrollbar-outer'));
                    smartupModalScrollToFare($wrapper);
                }
            });
        });
    }

    function smartupModalScrollToFare($wrapper) {
        var $button = $wrapper.find('.js-smartup-fares'),
            $node = $wrapper.find('.js-choose-fare'),
            $header_mobile = $wrapper.find('.header-mobile'),
            header_mobile_height = $header_mobile.outerHeight(true);

        $button.on('click', function (e) {
            e.preventDefault();

            if (!$.sa.is_mobile()) {
                header_mobile_height = 0;
            }

            var $modal_content = $wrapper.find('.scrollbar-outer.scroll-content'),
                node_position = $node.offset().top -
                    $.sa.$document.scrollTop() +
                    $modal_content.scrollTop() -
                    header_mobile_height;

            $modal_content.animate({
                scrollTop: node_position
            }, 300);
        });
    }

    function initSmartupBrandModal() {
        $.sa.$document.on('click', '.js-modal-smartup-brand', function (e) {
            e.preventDefault();

            var $wrapper = $($.sa.smartup_brand_modal).clone();

            $.uiModal({
                $wrapper: $wrapper
            });
        });
    }

    function initSmartupBrandModalLogin() {
        if ($.sa.smartup_login) {
            var options = Object.assign({}, $.sa.smartup_login, {
                modal_options: {
                    onOpen($modal_wrapper) {
                        $modal_wrapper.addClass('smartup-login');
                    }
                }
            });
            new AuthModal(options);
        }
    }

    function initSmartupSupportChat() {
        $.sa.$document.on('click', '.js-smartup-support-chat-open', function (e) {
            e.preventDefault();
            $.sa.$document.find('#hde-chat-button').trigger('click');
        });
    }

    function initErrorHandler() {
        window.onerror = function (message, file, line, col, error) {
            $.sa.error('See: https://stackoverflow.com/search?q=' + encodeURI(error.message));
        };
        window.addEventListener('error', function (e) {
            $.sa.error('See: https://stackoverflow.com/search?q=' + encodeURI(e.error.message));
        })
    }

    function initContentRouter() {
        $.sa.content_router = new ContentRouter({
            $content: $.sa.$content,
            app_url: $.sa.route_uri,
            onLoad: function () {
                $.sa.loading_bar.animate(10000, 80, false);
                setupLayout();
                cleanUrl();
                setupLocaleSwitchUrls();
            },
            onDone: function () {
                $.sa.loading_bar.done();
                setupLayout();
                cleanUrl();
                setupLocaleSwitchUrls();
                $.sa.mobile_app.nav_bar.define();
            },
            onFail: function () {
                $.sa.loading_bar.abort();
                setupLayout();
                cleanUrl();
                setupLocaleSwitchUrls();
                $.sa.mobile_app.nav_bar.define();
            }
        });
    }

    function setupLayout() {
        var $body = $.sa.$document.find('body'),
            layout = $.sa.get_layout();

        $.each($.sa.layout, function (i, item) {
            if (layout !== i) {
                $body.removeClass(item.class);
            }
        });

        $body.addClass($.sa.layout[layout].class);
    }

    function cleanUrl() {
        /** @see aviaConfig::GET_FROM_NAME, aviaStorefront::GET_KEY, aviaPartnerAPIMethod::API_REQUEST_ID and  aviaPartnerAPIMethod::PARTNER_REQUEST_ID at partner_api */
        var purgeable_params = ['locale', 'logout', 'strf', 'link_id', 'request_id', 'active_screen', 'v', 'from'],
            url = new URL(document.location.href),
            params = url.searchParams,
            leftover_params = new URLSearchParams(),
            update_is_needed = false;

        params.forEach(function (value, param) {
            if (purgeable_params.includes(param)) {
                update_is_needed = true;
            } else {
                leftover_params.append(param, value);
            }
        });

        if (update_is_needed) {
            var clean_url = url.pathname;
            leftover_params = leftover_params.toString();
            if (leftover_params.length) {
                clean_url += '?' + leftover_params;
            }
            window.history.replaceState({}, '', clean_url);
        }
    }

    function setupLocaleSwitchUrls() {
        var layout_env = $.sa.get_layout(),
            url = new URL(document.location.href),
            escaped_current_locale_route_path = $.sa.current_locale_config['route_path'].replace(/\//g, '\\/'),
            pattern = new RegExp(`^\\/(${escaped_current_locale_route_path})?(.+?)?`, 'g'),
            cleaned_pathname = url.pathname.replace(pattern, '$2');

        $.each($.sa.support_locales, function (locale_code, locale_config) {
            var params = url.searchParams,
                locale_witch_url = '/' + cleaned_pathname;

            if (layout_env === $.sa.layout.site.name) {
                locale_witch_url = '/' + locale_config['route_path'] + cleaned_pathname;
            } else {
                params.set('locale', locale_code);
            }

            var params_as_sting = params.toString();
            if (params_as_sting.length) {
                locale_witch_url += '?' + params_as_sting;
            }

            $('.js-locale-switch[data-locale="' + locale_code + '"]').attr('href', locale_witch_url);
        });
    }

    function showConfirm(options) {
        var class_button = (options['class_button'] || 'primary'),
            class_header = (options['class_header'] || ''),
            class_content = (options['class_content'] || ''),
            class_buttons = (options['class_buttons'] || 'flex-right'),
            icons = (options.icons || ''),
            title = (options.title || ''),
            content = (options.content || ''),
            button_cancel = (options.button_cancel || $.sa.locales['cancel']),
            button = (options.button || $.sa.locales['confirm']),
            onConfirm = (options.onConfirm || function () {}),
            onClose = (options.onClose || function () {});

        var template = $.sa.confirm.template;

        template = template
            .replace('%class_header%', class_header)
            .replace('%class_content%', class_content)
            .replace('%class_buttons%', class_buttons)
            .replace('%icons%', icons)
            .replace('%title%', title)
            .replace('%content%', content)
            .replace('%button_cancel%', button_cancel)
            .replace('%button%', button);

        if (!template) {
            throw 'Not found confirm modal template';
        }

        var modal = $.uiModal({
            html: template,
            onClose: onClose,
            onBgClick: function () {
                return false;
            }
        });

        modal.$wrapper.find('.js-confirm').addClass(class_button).on('click', confirm);

        var $header_icons = modal.$wrapper.find('.js-modal-header-icons');
        if (!icons.length) {
            $header_icons.remove();
        }

        function confirm() {
            onConfirm(modal.$wrapper, modal);
            modal.close();
        }

        return modal;
    }

    function showAlert(options) {
        var title = (options['title'] || ''),
            content = (options['content'] || ''),
            button = (options['button'] || 'OK'),
            class_button = (options['class_button'] || 'primary'),
            onConfirm = (options.onConfirm || function () {});

        var template = $.sa.alert.template;

        template = template
            .replace('%title%', title)
            .replace('%content%', content)
            .replace('%button%', button);

        if (!template) {
            throw 'Not found alert modal template';
        }

        var modal = $.uiModal({
                html: template,
                onBgClick: function () {
                    return false;
                }
            }),
            $confirm_button = modal.$wrapper.find('.js-confirm');

        $confirm_button
            .addClass(class_button)
            .on('click', confirm);

        function confirm() {
            onConfirm(modal.$wrapper, modal);
            modal.close();
        }

        return modal;
    }

    function showNotifier(options) {
        var title = (options['title'] || ''),
            content = (options['content'] || ''),
            notifier_class = (options['notifier_class'] || 'warning'),
            icon_class = (options['icon_class'] || null),
            button_confirm_text = (options['button_confirm_text'] || null),
            button_confirm_onclick = (options['button_confirm_onclick'] || null),
            button_cancel_text = (options['button_cancel_text'] || null),
            button_cancel_onclick = (options['button_cancel_onclick'] || null),
            render_close_icon = options['render_close_icon'],
            time = options['time'];

        var template = $.sa.notifier.template;
        if (!template) {
            throw 'Not found notifier dialog';
        }

        if (!icon_class) {
            switch (notifier_class) {
                case $.sa.notifier.class.success:
                    icon_class = 'fab fa-sa-circle-check';
                    break;
                case $.sa.notifier.class.plain:
                    icon_class = 'fab fa-sa-warning-circle';
                    break;
                case $.sa.notifier.class.error:
                    icon_class = 'fab fa-sa-warning-circle';
                    break;
                case $.sa.notifier.class.accent:
                    icon_class = 'fab fa-sa-info';
                    break;
                case $.sa.notifier.class.warning:
                default:
                    icon_class = 'fab fa-sa-warning';
                    break;
            }
        }

        var $notifier = $(template);

        if (render_close_icon !== false || !button_confirm_text) {
            $notifier.find('.js-notifier-close-wrapper').show();
        }

        $notifier.find('.js-notifier-icon').addClass(icon_class);
        $notifier.find('.js-title').html(title);
        $notifier.find('.js-content').html(content);

        // Buttons
        if (button_confirm_text) {
            $notifier.find('.js-buttons').show();

            $notifier.find('.js-button-confirm').text(button_confirm_text).show();
            $notifier.on('click', '.js-button-confirm', function (e) {
                e.preventDefault();
                hide();
                if (button_confirm_onclick && typeof button_confirm_onclick === 'function') {
                    button_confirm_onclick();
                }
            });

            if (button_cancel_text) {
                $notifier.find('.js-button-cancel').text(button_cancel_text).show();
                $notifier.on('click', '.js-button-cancel', function (e) {
                    e.preventDefault();
                    hide();
                    if (button_cancel_onclick && typeof button_cancel_onclick === 'function') {
                        button_cancel_onclick();
                    }
                });
            }
        }

        $notifier.addClass(notifier_class);

        $notifier.on('click', '.js-notifier-close', hide);

        show();

        if (!button_confirm_text || time || render_close_icon !== false) {
            setTimeout(hide, (time || 10000));
        }

        return $notifier;

        function show() {
            $notifier
                .addClass('animated')
                .addClass('bounceInRight');

            $('#notifier-wrapper').append($notifier);
        }

        function hide() {
            $notifier
                .removeClass('bounceInRight')
                .addClass('bounceOutRight');

            setTimeout(function () {
                $notifier.remove();
            }, 500);
        }
    }

    function initSetCookie() {
        $.sa.$document.on('click', '.js-set-cookie', function (e) {
            var set_trigger = $(this),
                cookie_name = set_trigger.data('cookie-name'),
                cookie_value = set_trigger.data('cookie-value'),
                cookie_max_age_days = set_trigger.data('cookie-max-age-days') || '',
                cookie_path = set_trigger.data('cookie-path') || '/';

            // convert max age in days
            if (cookie_max_age_days) {
                cookie_max_age_days = cookie_max_age_days * 60 * 60 * 24;
            }

            $.sa.setCookie(cookie_name, cookie_value, cookie_path, cookie_max_age_days);
        });
    }

    function initResetCookie() {
        $.sa.$document.on('click', '.js-reset-cookie', function (e) {
            var set_trigger = $(this),
                cookie_name = set_trigger.data('cookie-name'),
                cookie_path = set_trigger.data('cookie-path') || '/';

            $.sa.setCookie(cookie_name, '', cookie_path, -1);
        });
    }

    function initRefreshUrl() {
        $.sa.$document.on('click', '.js-refresh-url', function (e) {
            var url = window.location.href;
            $.sa.content_router.load(url);
        });
    }
})(jQuery);
